import React from 'react'
import { Helmet } from 'react-helmet-async'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Contact from '../components/Contact'
import FAQ from '../components/FAQ'
import PageMeta from '../components/PageMeta'

const ContactPage = () => {
  return (
    <div>
      <PageMeta 
        title="Contact Web Designer Centurion | Free Quote | RDS Studio"
        description="Get a free web design quote from Centurion's trusted digital agency. Custom WordPress sites, SEO & Google Ads. Call or email — we respond within 1 business day."
        canonical="https://rdsstudio.co.za/contact"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "@id": "https://rdsstudio.co.za/contact#webpage",
            "url": "https://rdsstudio.co.za/contact",
            "name": "Contact RDS Studio | Free Discovery Call",
            "description": "Contact RDS Studio for a free discovery call about your web development, digital marketing or SEO project.",
            "isPartOf": { "@id": "https://rdsstudio.co.za/#website" },
            "about": { "@id": "https://rdsstudio.co.za/#organization" },
            "inLanguage": "en-ZA"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://rdsstudio.co.za/#localbusiness",
            "name": "RDS Studio",
            "image": "https://rdsstudio.co.za/images/logo/og-image.png",
            "url": "https://rdsstudio.co.za",
            "telephone": "+27846390621",
            "email": "info@rdsstudio.co.za",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Centurion",
              "addressRegion": "Gauteng",
              "postalCode": "0157",
              "addressCountry": "ZA"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "-25.8601",
              "longitude": "28.1890"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
              "opens": "09:00",
              "closes": "18:00"
            },
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61579996723546",
              "https://www.instagram.com/rdsstudio1111/",
              "https://www.linkedin.com/in/jean-pierre-matthys-du-toit-7671493a3/",
              "https://www.youtube.com/channel/UCqEgC_kMwk4MqEcIC_yCayw"
            ]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What services does RDS Studio offer?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "RDS Studio offers web development (WordPress, React), private cloud setup, digital marketing (Google Ads, Meta Ads), SEO optimization, custom CMS development, and LMS & online course creation."
                }
              },
              {
                "@type": "Question",
                "name": "How much does a website cost at RDS Studio?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "A basic WordPress site starts from R8,500. Custom web applications range from R35,000 to R85,000. Contact RDS Studio for a tailored quote."
                }
              },
              {
                "@type": "Question",
                "name": "How long does it take to build a website?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Simple WordPress sites take 2-3 weeks, custom business websites take 4-6 weeks, and complex web applications take 8-12 weeks."
                }
              },
              {
                "@type": "Question",
                "name": "Where is RDS Studio located?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "RDS Studio is based in Centurion, Gauteng, South Africa. We serve clients nationwide and remotely. In-person meetings are available for local clients."
                }
              },
              {
                "@type": "Question",
                "name": "What is your payment structure?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "For website projects: 50% deposit to start, 50% on completion. Monthly services (SEO, hosting, maintenance) are billed monthly in advance."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      <Header />
      <main className="main-content">
        <Contact useH1={true} />
        <FAQ />
      </main>
      <Footer />
    </div>
  )
}

export default ContactPage
